import { useState } from "react";
import { fetchResponseAdapter } from "../../../../../adapters/fetchAdapter";
import useCallApiAndLoad from "../../../../../hooks/useCallApiAndLoad";
import { getDetailUserUnit } from "../../../services/devsServices";
import { useDispatch, useSelector } from "react-redux";
import { unsetAuth } from "../../../../../helpers/authHelper";
import { getAuthToken } from "../../../../../helpers/authHelper";
import { useNavigate } from "react-router-dom";
import { AppStore } from "../../../../../redux/store";
import { logoutAction } from "../../../../../redux/features/auth";
import { UserUnit } from "../../../../../models/presales";

export const useDetailProjectUserUnit = () => {
  const user = useSelector((store: AppStore) => store.auth);
  const token = require("../../../../../helpers/authHelper").getAuthToken(user);
  const { country } = useSelector((store: AppStore) => store.country);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [usersUnit, setUsersUnit] = useState<UserUnit>();
  const [detailProjectUserUnitLoading, setDetailProjectUserUnitLoading] = useState(false);
  const { callEndpoint } = useCallApiAndLoad();

  const getDetailUnitUser = async (idProject: string, idUnit: string) => {
    if (usersUnit) return; // Si ya hay datos, no consultar
    setDetailProjectUserUnitLoading(true);
    try {
      const { status, data } = await callEndpoint(getDetailUserUnit(token, idProject, idUnit));
      if (status === 401) {
        setDetailProjectUserUnitLoading(false);
        dispatch(logoutAction({}));
        unsetAuth();
        navigate(`/app/${country}/auth/desarrolladoras/login`);
      }
      if (status === 200) {
        const response = fetchResponseAdapter(data);
        setDetailProjectUserUnitLoading(false);
        setUsersUnit(response.data);
      }
    } catch (error) {
      setDetailProjectUserUnitLoading(false);
      console.log(error);
    }
  };

  return { usersUnit, detailProjectUserUnitLoading, getDetailUnitUser };
};
